import Vue from 'vue'
import App from './App'
import Vuetify from 'vuetify'
import * as VueGoogleMaps from 'vue2-google-maps'
import GmapCluster from 'vue2-google-maps/dist/components/cluster' // replace src with dist if you have Babel issues
import * as ModalDialogs from 'vue-modal-dialogs'
import VueChartkick from 'vue-chartkick'
import Chart from 'chart.js'

import store from './store'
import router from './router'

import 'vuetify/dist/vuetify.min.css'
import '@fortawesome/fontawesome-free-webfonts/scss/fontawesome.scss'
import '@fortawesome/fontawesome-free-webfonts/scss/fa-solid.scss'

Vue.use(Vuetify)
Vue.use(
  VueGoogleMaps,
  {
    load: {
      key: process.env.VUE_APP_GMAP_API_KEY,
    },
  }
)
Vue.component('GmapCluster', GmapCluster)
Vue.use(ModalDialogs) // No options
Vue.use(VueChartkick, {adapter: Chart})
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
})
